<mat-card class="map-container">
  <div class="chart-container bar">
    <canvas [id]="this.id">{{ chart }}</canvas>
  </div>
</mat-card>
